export async function updateNumberCartCount(idCartCount) {
  try {
    const response = await fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(`Error fetching cart data: ${response.statusText}`);
    }
    const data = await response.json();
    if (idCartCount) {
      if(data.item_count >  0){
        idCartCount.style.visibility = 'visible'
      } else {
        idCartCount.style.visibility = 'hidden'
      }
      const itemCount = data.item_count;
      idCartCount.textContent = itemCount;
    }
  } catch (error) {
    console.error('Error fetching cart data:', error);
  }
}